import React, { VFC } from 'react'

import styled from 'styled-components'

import { Tooltip } from 'src/components/atoms'
import { FormItemTitle } from 'src/components/molecules'

import { useDevice } from 'src/hooks'

const TitleWrapper = styled.div<{ width: number | undefined; isPC: boolean }>`
  // PCサイズ以下の場合タイトル部分がFormItemの上にくるため、widthはauto固定
  width: ${props => (props.isPC ? (props.width ? `${props.width}rem` : '7.44rem') : 'auto')};
  flex-shrink: 0;
  margin-right: var(--s-1);
`

type Props = {
  title: string | React.ReactNode
  showRequired?: boolean
  isTitleCentering?: boolean
  width?: number
  tooltipContent?: React.ReactNode
  children: React.ReactNode
  className?: string
}

export const FormItemHorizontal: VFC<Props> = ({
  title,
  showRequired,
  isTitleCentering = true,
  width,
  tooltipContent,
  children,
  className,
}) => {
  const { isPC } = useDevice()

  return (
    <div className={className}>
      <div className={`laptop:tw-flex ${isTitleCentering ? 'tw-items-center' : ''}`}>
        <TitleWrapper width={width} isPC={isPC}>
          {tooltipContent ? (
            <Tooltip content={tooltipContent} placement="top">
              <FormItemTitle text={title} showRequired={showRequired} />
            </Tooltip>
          ) : (
            <FormItemTitle text={title} showRequired={showRequired} />
          )}
        </TitleWrapper>
        <div className="tw-mt-6 laptop:tw-mt-0 tw-w-full">{children}</div>
      </div>
    </div>
  )
}
